var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0316 25.472C29.915 25.472 34.6844 20.7026 34.6844 14.8192C34.6844 8.9359 29.915 4.1665 24.0316 4.1665C18.1483 4.1665 13.3789 8.9359 13.3789 14.8192C13.3789 20.7026 18.1483 25.472 24.0316 25.472Z",
    fill: "#121B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7916 43.8955C24.7792 41.7339 23.5473 38.8364 23.5473 35.6522C23.5473 32.3924 24.8392 29.431 26.9388 27.2539C25.9897 27.1803 25.0193 27.1416 24.0315 27.1416C17.5973 27.1416 11.901 28.7511 8.36427 31.1625C5.66622 33.0025 4.17871 35.3403 4.17871 37.7943V40.6028C4.17871 41.4763 4.52541 42.315 5.14327 42.9309C5.76113 43.5488 6.59785 43.8955 7.47138 43.8955H26.7916Z",
    fill: "#121B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6529 25.4834C30.0399 25.4834 25.4844 30.0389 25.4844 35.6519C25.4844 41.2649 30.0399 45.8204 35.6529 45.8204C41.2659 45.8204 45.8214 41.2649 45.8214 35.6519C45.8214 30.0389 41.2659 25.4834 35.6529 25.4834ZM34.2003 35.6519V40.4941C34.2003 41.2959 34.851 41.9467 35.6529 41.9467C36.4548 41.9467 37.1055 41.2959 37.1055 40.4941V35.6519C37.1055 34.8501 36.4548 34.1993 35.6529 34.1993C34.851 34.1993 34.2003 34.8501 34.2003 35.6519ZM35.6529 29.3571C36.722 29.3571 37.5898 30.2248 37.5898 31.294C37.5898 32.3631 36.722 33.2308 35.6529 33.2308C34.5838 33.2308 33.716 32.3631 33.716 31.294C33.716 30.2248 34.5838 29.3571 35.6529 29.3571Z",
    fill: "#121B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.f8b1a8694164340cb1901b1c6fbee33a.svg";
export { ForwardRef as ReactComponent };